import React from 'react'
import '../static/css/login.css'
function Signup() {
    return (
        <div>

        </div>
    )
}

export default Signup
